export class FlowPageDoesNotExists extends Error {}
